import React from 'react'
import canAutoPlay from 'can-autoplay'
import { detectBrowser } from '../../utils/detectBrowser'
import Icon from '../misc/Icons'
import AutoPlaySetupBrowserInstructions from './AutoPlaySetupBrowserInstructions'
import analytics from '../../utils/cdpAnalytics'

class AutoplaySetupContent extends React.Component {
  constructor() {
    super()
    this.playSound = this.playSound.bind(this)
    this.selectBrowser = this.selectBrowser.bind(this)

    const browser = detectBrowser()
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
    const selectedOS = isMac ? 'mac' : 'windows'

    this.state = {
      browser,
      isMac,
      selectedBrowser: null,
      autoplayFailed: null,
      selectedOS,
    }
  }

  componentDidMount() {
    let selectedBrowser
    canAutoPlay.audio().then(({ result }) => {
      if (result === true) {
        selectedBrowser = this.state.browser
        this.setState({ selectedBrowser })
      } else if (this.state.browser !== 'chrome') {
        selectedBrowser = this.state.browser
        this.setState({ selectedBrowser })
      }
      let chromeClickRequired = true
      if (selectedBrowser) {
        chromeClickRequired = false
      }
      let browserOS
      if (this.state.isMac) {
        browserOS = `mac ${this.state.browser}`
      } else {
        browserOS = `win ${this.state.browser}`
      }

      analytics.page('AutoPlay setup', {
        type: this.props.isModal ? 'modal' : 'page',
        chromeClickRequired,
        browserOS,

      })
    })
    if (this.autoplayAudio) {
      this.autoplayAudio.volume = 0.01
    }
  }

  playSound() {
    if (this.audio) {
      this.audio.volume = 0.01
      this.audio.play()
    }
  }

  selectBrowser(broswer) {
    this.setState({ selectedBrowser: broswer })
    if (broswer === 'chrome') {
      this.playSound()
    }
  }

  render() {
    const { selectedBrowser, selectedOS, autoplayFailed } = this.state
    const { isModal } = this.props

    const chromeIconCloudinary = 'https://assets.plickers.com/react-assets/images/setupautoplay/chrome.png'
    const firefoxIconCloudinary = 'https://assets.plickers.com/react-assets/images/setupautoplay/firefox.png'
    const edgeIconCloudinary = 'https://assets.plickers.com/react-assets/images/setupautoplay/edge.png'
    const safariIconCloudinary = 'https://assets.plickers.com/react-assets/images/setupautoplay/safari.png'

    const macChromeVideoCloudinary = 'https://assets.plickers.com/react-assets/video/setupautoplay/macchrome.mp4'
    const macFirefoxVideoCloudinary = 'https://assets.plickers.com/react-assets/video/setupautoplay/macfirefox.mp4'
    const macSafariVideoCloudinary = 'https://assets.plickers.com/react-assets/video/setupautoplay/macsafari.mp4'

    const winChromeVideoCloudinary = 'https://assets.plickers.com/react-assets/video/setupautoplay/winchrome.mp4'
    const winFirefoxVideoCloudinary = 'https://assets.plickers.com/react-assets/video/setupautoplay/winfirefox.mp4'
    const winEdgeVideoCloudinary = 'https://assets.plickers.com/react-assets/video/setupautoplay/winedge.mp4'

    return (
      <div className='autoPlaySetup'>

        <div className='autoPlaySetup-topRightContainer'>
          <div className='autoPlaySetup-osToggle'>
            <button onClick={() => (this.setState({ selectedOS: 'windows', selectedBrowser: 'chrome' }))} className={`autoPlaySetup-osToggle-toggle ${selectedOS === 'windows' ? 'autoPlaySetup-osToggle-toggle--active' : 'autoPlaySetup-osToggle-toggle--inactive'}`}>
              Windows
            </button>
            <button onClick={() => (this.setState({ selectedOS: 'mac', selectedBrowser: 'chrome' }))} className={`autoPlaySetup-osToggle-toggle ${selectedOS === 'mac' ? 'autoPlaySetup-osToggle-toggle--active' : 'autoPlaySetup-osToggle-toggle--inactive'}`}>
              Mac OS
            </button>
          </div>

          {isModal && (
          <button className='autoPlaySetup-closeBtn' onClick={this.props.closeModal}>
            <Icon name='close' />
          </button>
          )}

        </div>
        <div className='autoPlaySetup-h1'>
          How to enable your Plickers iOS/Android app
          <br />
          {' '}
          to play media on plickers.com
        </div>

        {/* UNSELECTED STATE, FOR CHROME */}
        {!selectedBrowser && (
        <div className='autoPlaySetup-initialBrowser'>
          <div className='autoPlaySetup-initialBrowser-h2'>
            Select your browser
          </div>
          <div className='autoPlaySetup-initialBrowser-btnArray'>

            <button onClick={() => { this.selectBrowser('chrome'); this.playSound() }} className='autoPlaySetup-initialBrowser-btnArray-button'>
              <div className='autoPlaySetup-initialBrowser-btnArray-button-iconContainer'>
                <img alt='' src={chromeIconCloudinary} />
              </div>
              <div className='autoPlaySetup-initialBrowser-btnArray-button-label'>
                Chrome
              </div>
            </button>
            {selectedOS === 'mac' && (
            <button onClick={() => { this.selectBrowser('safari') }} className='autoPlaySetup-initialBrowser-btnArray-button'>
              <div className='autoPlaySetup-initialBrowser-btnArray-button-iconContainer'>
                <img alt='' src={safariIconCloudinary} />
              </div>
              <div className='autoPlaySetup-initialBrowser-btnArray-button-label'>
                Safari
              </div>
            </button>
            )}
            <button onClick={() => { this.selectBrowser('firefox') }} className='autoPlaySetup-initialBrowser-btnArray-button'>
              <div className='autoPlaySetup-initialBrowser-btnArray-button-iconContainer'>
                <img alt='' src={firefoxIconCloudinary} />
              </div>
              <div className='autoPlaySetup-initialBrowser-btnArray-button-label'>
                Firefox
              </div>
            </button>

            {selectedOS === 'windows' && (
            <button onClick={() => { this.selectBrowser('edge') }} className='autoPlaySetup-initialBrowser-btnArray-button'>
              <div className='autoPlaySetup-initialBrowser-btnArray-button-iconContainer'>
                <img alt='' src={edgeIconCloudinary} />
              </div>
              <div className='autoPlaySetup-initialBrowser-btnArray-button-label'>
                Edge
              </div>
            </button>
            )}

          </div>

        </div>
        )}

        {/* NORMAL STATE WITH BROWSER IDENTIFIED */}
        {selectedBrowser && (
        <div className='autoPlaySetup-selectedBrowserContainer'>

          <div className='autoPlaySetup-selectedBrowser-btnArray'>

            <button onClick={() => { this.selectBrowser('chrome'); this.playSound() }} className={`autoPlaySetup-selectedBrowser-btnArray-button ${selectedBrowser === 'chrome' ? 'autoPlaySetup-selectedBrowser-btnArray-button--active' : 'autoPlaySetup-selectedBrowser-btnArray-button--inactive'}`}>
              <div className='autoPlaySetup-selectedBrowser-btnArray-button-iconContainer'>
                <img alt='' src={chromeIconCloudinary} />
              </div>
              <div className='autoPlaySetup-selectedBrowser-btnArray-button-label'>
                Chrome
              </div>
            </button>
            {selectedOS === 'mac' && (
            <button onClick={() => { this.selectBrowser('safari') }} className={`autoPlaySetup-selectedBrowser-btnArray-button ${selectedBrowser === 'safari' ? 'autoPlaySetup-selectedBrowser-btnArray-button--active' : 'autoPlaySetup-selectedBrowser-btnArray-button--inactive'}`}>
              <div className='autoPlaySetup-selectedBrowser-btnArray-button-iconContainer'>
                <img alt='' src={safariIconCloudinary} />
              </div>
              <div className='autoPlaySetup-selectedBrowser-btnArray-button-label'>
                Safari
              </div>
            </button>
            )}
            <button onClick={() => { this.selectBrowser('firefox') }} className={`autoPlaySetup-selectedBrowser-btnArray-button ${selectedBrowser === 'firefox' ? 'autoPlaySetup-selectedBrowser-btnArray-button--active' : 'autoPlaySetup-selectedBrowser-btnArray-button--inactive'}`}>
              <div className='autoPlaySetup-selectedBrowser-btnArray-button-iconContainer'>
                <img alt='' src={firefoxIconCloudinary} />
              </div>
              <div className='autoPlaySetup-selectedBrowser-btnArray-button-label'>
                Firefox
              </div>
            </button>

            {selectedOS === 'windows' && (
            <button onClick={() => { this.selectBrowser('edge') }} className={`autoPlaySetup-selectedBrowser-btnArray-button ${selectedBrowser === 'edge' ? 'autoPlaySetup-selectedBrowser-btnArray-button--active' : 'autoPlaySetup-selectedBrowser-btnArray-button--inactive'}`}>
              <div className='autoPlaySetup-selectedBrowser-btnArray-button-iconContainer'>
                <img alt='' src={edgeIconCloudinary} />
              </div>
              <div className='autoPlaySetup-selectedBrowser-btnArray-button-label'>
                Edge
              </div>
            </button>
            )}

          </div>

          <div className='autoPlaySetup-selected-h2'>
            Instructions
          </div>

          <AutoPlaySetupBrowserInstructions
            browser={selectedBrowser}
            os={selectedOS}
            autoplayFailed={autoplayFailed}
          />

          <div className={`autoPlaySetup-selected-videoContainer ${(selectedBrowser === 'edge' && selectedOS === 'windows') ? 'autoPlaySetup-selected-videoContainer--winEdge' : ''}`}>
            {selectedBrowser === 'chrome' && selectedOS === 'mac' && (
            <video autoPlay loop muted preload='auto' className='autoPlaySetup-selected-video autoPlaySetup-selected-video--macChrome'>
              <source src={macChromeVideoCloudinary} type='video/mp4' />
            </video>
            )}

            {selectedBrowser === 'firefox' && selectedOS === 'mac' && (
            <video autoPlay loop muted preload='auto' className='autoPlaySetup-selected-video autoPlaySetup-selected-video--macFirefox'>
              <source src={macFirefoxVideoCloudinary} type='video/mp4' />
            </video>
            )}

            {selectedBrowser === 'safari' && selectedOS === 'mac' && (
            <video autoPlay loop muted preload='auto' className='autoPlaySetup-selected-video autoPlaySetup-selected-video--macSafari'>
              <source src={macSafariVideoCloudinary} type='video/mp4' />
            </video>
            )}

            {selectedBrowser === 'chrome' && selectedOS === 'windows' && (
            <video autoPlay loop muted preload='auto' className='autoPlaySetup-selected-video autoPlaySetup-selected-video--winChrome'>
              <source src={winChromeVideoCloudinary} type='video/mp4' />
            </video>
            )}

            {selectedBrowser === 'firefox' && selectedOS === 'windows' && (
            <video autoPlay loop muted preload='auto' className='autoPlaySetup-selected-video autoPlaySetup-selected-video--winFirefox'>
              <source src={winFirefoxVideoCloudinary} type='video/mp4' />
            </video>
            )}

            {selectedBrowser === 'edge' && selectedOS === 'windows' && (
            <video autoPlay loop muted preload='auto' className='autoPlaySetup-selected-video autoPlaySetup-selected-video--winEdge'>
              <source src={winEdgeVideoCloudinary} type='video/mp4' />
            </video>
            )}

          </div>

        </div>
        )}

        {selectedBrowser && isModal && (
        <button className='autoPlaySetup-doneBtn' onClick={this.props.closeModal}>
          Done
        </button>
        )}

        {/* }
    Autoplay Setup Content
    isModal:{`${this.props.isModal}`}
    <br/>
    browser:{this.state.browser}
    <br/>
    isMac:{`${this.state.isMac}`}
    <br/>
    selectedBrowser:{selectedBrowser}
    <br/>
    autoplayFailed:{`${this.state.autoPlayFailed}`}
    <br/>
    <br/>
    <button onClick={()=>{this.selectBrowser('chrome')}}>chrome</button><br/>
    <button onClick={()=>{this.selectBrowser('safari')}}>safari</button><br/>
    <button onClick={()=>{this.selectBrowser('edge')}}>edge</button><br/>

      <button >play</button>

*/}

        <audio ref={(ref) => { this.audio = ref }} src='https://assets.plickers.com/react-assets/sound/5dc7674e20197fb3ff8838f4bd0e9a67.mp3'>
          <track kind='captions' srcLang='en"' label='Audio auto play' src='' default />
        </audio>
        <audio ref={(ref) => { this.autoplayAudio = ref }} autoPlay src='https://assets.plickers.com/react-assets/sound/5dc7674e20197fb3ff8838f4bd0e9a67.mp3'>
          <track kind='captions' srcLang='en"' label='Audio auto play' src='' default />
        </audio>
      </div>

    )
  }
}

export default AutoplaySetupContent

// <audio autoPlay loop src={'https://media.plickers.com/video/upload/sound/0f4292694deca3848b36ba78d147c202.mp3'}/>
// <video autoPlay loop muted={false} src={URL.createObjectURL(Media.VIDEO)}/>
// <audio autoPlay loop muted={false} src={URL.createObjectURL(Media.AUDIO)}/>
